import { render } from "./SimpleWizard1.vue?vue&type=template&id=6ab82152"
import script from "./SimpleWizard1.vue?vue&type=script&lang=js"
export * from "./SimpleWizard1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__